var map = {
	"./encoding": 52,
	"./encoding.js": 52,
	"./iconv-loader": 76,
	"./iconv-loader.js": 76
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;



/*****************
 ** WEBPACK FOOTER
 ** ../~/encoding/lib ^\.\/.*$
 ** module id = 77
 ** module chunks = 0
 **/